import styled from "styled-components";
import { pageMargins, pageMarginsRight } from "@/lib/styles/helpers";
import { H2, P } from "@/lib/styles";

export const Container = styled.article`
  ${pageMargins};
  padding: 2.5rem 0;

  background: ${({ theme }) => theme.colors.white};
  position: relative;

  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 2.5rem;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    ${pageMarginsRight};
    margin-left: 0 !important;
    top: -10rem;
    grid-column: 2 / -1;
  }

  ${({ theme }) => theme.mediaQueries.desktop} {
    margin-right: 0 !important;
  }
`;

export const Heading = styled(H2)`
  margin-bottom: 2.5rem;
`;